/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const notificationPolicyUpdateExpectedVersionExclusiveMin = 0;
export const notificationPolicyUpdateExpectedVersionMax = 9007199254740991;

export const notificationPolicyUpdateNameMax = 120;

export const notificationPolicyUpdateStepsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyUpdateStepsItemPositionMin = 0;
export const notificationPolicyUpdateStepsItemPositionMax = 9007199254740991;

export const notificationPolicyUpdateStepsItemDelayMinutesMin = 0;
export const notificationPolicyUpdateStepsItemDelayMinutesMax = 1440;

export const notificationPolicyUpdateStepsItemTargetOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyUpdateStepsItemTargetTwoScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyUpdateStepsItemTargetThreeTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const notificationPolicyUpdateStepsItemChannelsMax = 3;

export const NotificationPolicyUpdate = zod.object({
  expectedVersion: zod
    .int()
    .gt(notificationPolicyUpdateExpectedVersionExclusiveMin)
    .max(notificationPolicyUpdateExpectedVersionMax),
  name: zod.string().min(1).max(notificationPolicyUpdateNameMax),
  enabled: zod.boolean(),
  steps: zod
    .array(
      zod.object({
        id: zod.uuid().regex(notificationPolicyUpdateStepsItemIdRegExp),
        position: zod
          .int()
          .min(notificationPolicyUpdateStepsItemPositionMin)
          .max(notificationPolicyUpdateStepsItemPositionMax),
        delayMinutes: zod
          .int()
          .min(notificationPolicyUpdateStepsItemDelayMinutesMin)
          .max(notificationPolicyUpdateStepsItemDelayMinutesMax),
        condition: zod.enum(['not-acknowledged', 'not-resolved']),
        target: zod.union([
          zod.object({
            kind: zod.literal('user'),
            userId: zod.uuid().regex(notificationPolicyUpdateStepsItemTargetOneUserIdRegExp),
          }),
          zod.object({
            kind: zod.literal('schedule'),
            scheduleId: zod
              .uuid()
              .regex(notificationPolicyUpdateStepsItemTargetTwoScheduleIdRegExp),
          }),
          zod.object({
            kind: zod.literal('team'),
            teamId: zod.uuid().regex(notificationPolicyUpdateStepsItemTargetThreeTeamIdRegExp),
          }),
        ]),
        channels: zod
          .array(zod.enum(['email', 'sms', 'voice']))
          .min(1)
          .max(notificationPolicyUpdateStepsItemChannelsMax),
      }),
    )
    .min(1),
});

export type NotificationPolicyUpdate = zod.input<typeof NotificationPolicyUpdate>;
export type NotificationPolicyUpdateOutput = zod.output<typeof NotificationPolicyUpdate>;
